import { atomWithReset } from "jotai/utils";

export const locationAllDTOAtom = atomWithReset({
  locationINData: {
    zipCode: "",
    address: "",
    country: "",
    city: "",
    state: "",
    latitude: "",
    longitude: "",
  },
  projectData: {
    projectName: "",
    projectDescription: "",
    customerName: "",
    currency: "",
    projectType: "ANSI",
  },
});
